export default __webpack_public_path__ + "static/polygon-bc27724c5eb8e532bd2945b268a63dc8.svg";